import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Table, TableRow, TableCell, TableBody, Typography, Button } from '@mui/material';
import RecentActorsIcon from '@mui/icons-material/RecentActors';

import AdvisorDashboardTile from './AdvisorDashboardTile';
import CircularProgress from 'app/components/shared/CircularProgress';

import { useGetRecentContactsQuery } from 'app/features/account/api/accountApi';
import { featureFlag } from 'app/util/featureFlag';

const AdvisorMostRecentContacts = () => {
  const { data, isLoading } = useGetRecentContactsQuery();
  let content = null;

  if (isLoading) {
    content = (<CircularProgress />);
  } else if (data && data.length === 0) {
    content = (
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Typography variant="h5" component="div">
          No Recent Contacts
        </Typography>
        <Typography variant="body2">
          Your latest interactions will appear here.
        </Typography>
        <Button variant="contained" color="primary" sx={{ mt: 2 }}>
          Promote
        </Button>
      </Box>
    );
  } else {
    content = (
      <Table sx={{ fontSize: '12px' }}>
        <TableBody>
          {data.map((contact) => (
            <TableRow key={`recent_contact_${contact[1]}`}>
              <TableCell sx={{ px: '8px', py: '2px', borderBottom: '0' }}>
                { featureFlag.enabled('CUSTOMERS_21626') ? (
                  <Link to={`/my_customers/user/${contact[0]}`}>
                    {contact[0]}
                  </Link>
                ) : (
                  <a href={`/my_customers/user/${contact[0]}`}>
                    {contact[0]}
                  </a>
                )}
              </TableCell>
              <TableCell sx={{ px: '8px', py: '2px', borderBottom: '0' }}>
                { contact[3] ? (
                  <a href={contact[3]}>
                    {contact[2]}
                  </a>
                ) : (
                  contact[2]
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <AdvisorDashboardTile
      title="Most Recent Contacts"
      icon={<RecentActorsIcon sx={{ color: '#888' }} />}
    >
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-around' }}>
        { content }
      </Box>

      <Link to="/my_customers" style={{ textDecoration: 'none', fontSize: '14px' }}>
        View All Customers
      </Link>
    </AdvisorDashboardTile>
  );
};

export default AdvisorMostRecentContacts;
